import axios from "axios";

function normalizeText(value) {
  if (typeof value !== "string") return value;

  const withoutAccents = value.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  const noSpecialChars = withoutAccents.replace(/[^a-zA-Z0-9\s]/g, " ");
  const collapsed = noSpecialChars.replace(/\s+/g, " ").trim().toLowerCase();

  if (!collapsed) return "";

  return collapsed
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

function normalizeUf(value) {
  const normalized = normalizeText(value);
  return typeof normalized === "string" ? normalized.toUpperCase() : normalized;
}

function normalizeViaCepPayload(payload, key = "") {
  if (Array.isArray(payload)) {
    return payload.map((item) => normalizeViaCepPayload(item, key));
  }

  if (payload && typeof payload === "object") {
    return Object.fromEntries(
      Object.entries(payload).map(([entryKey, value]) => [entryKey, normalizeViaCepPayload(value, entryKey)])
    );
  }

  if (key === "uf") {
    return normalizeUf(payload);
  }

  return normalizeText(payload);
}

function isCepGeral(viaCepPayload) {
  if (!viaCepPayload || typeof viaCepPayload !== "object") return false;
  const logradouro = String(viaCepPayload.logradouro || "").trim();
  const localidade = String(viaCepPayload.localidade || "").trim();
  const uf = String(viaCepPayload.uf || "").trim();
  return !logradouro && !!localidade && !!uf;
}

export const buscarEnderecoPorCep = async (cep) => {
  const instance = axios.create({
    baseURL: "https://viacep.com.br",
    withCredentials: false,
  });

  const response = await instance.get(`/ws/${cep}/json/`);
  if (response.data.erro) throw new Error("CEP nao encontrado");
  const normalized = normalizeViaCepPayload(response.data);
  return {
    ...normalized,
    cepGeral: isCepGeral(normalized),
  };
};
